module.exports = __webpack_public_path__ + "static/media/gc-caramel-solo.665118fb.png";